import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText } from "vue";
import _imports_0 from '../../../../public/img/qb16x16.png';
const _hoisted_1 = {
  class: "px-6 py-2",
  id: "tab-billing"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "flex w-full"
};
const _hoisted_4 = {
  class: "w-6/12 py-4"
};
const _hoisted_5 = {
  class: ""
};
const _hoisted_6 = {
  class: "w-6/12 text-center"
};
const _hoisted_7 = {
  key: 0,
  class: "py-2"
};
const _hoisted_8 = {
  class: "flex flex-col"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "flex w-full"
};
const _hoisted_11 = {
  class: "w-6/12"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  class: "w-6/12"
};
const _hoisted_14 = {
  class: "input-append"
};
const _hoisted_15 = {
  class: "flex w-full mb-4"
};
const _hoisted_16 = {
  class: "w-6/12"
};
const _hoisted_17 = {
  key: 0,
  class: "flex w-full"
};
const _hoisted_18 = {
  class: "w-6/12"
};
const _hoisted_19 = {
  class: "flex w-full"
};
const _hoisted_20 = {
  class: "w-6/12"
};
const _hoisted_21 = {
  class: "w-6/12"
};
const _hoisted_22 = {
  class: "input-append"
};
import MainHeader from "@/components/MainHeader.vue";
import SettingsSaveBar from "@/components/SettingsSaveBar.vue";
import Loader from "@/components/Loader.vue";
import RouteService from "@/services/RouteService";
import LlTooltip from "@/components/LlTooltip.vue";
import LlDoubleSwitch from "@/components/LlDoubleSwitch.vue";
import { useCompanyStore } from "@/services/UserService/useCompanyStore";
import { reactive, onMounted, computed, nextTick } from "vue";
import ProductNotice from "@/components/ProductNotice.vue";
import LlSelect from '@/components/LlSelect.vue';
export default {
  __name: 'CompanyWorkflow',
  props: {
    userService: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const companyStore = useCompanyStore();
    let workflowState = reactive({
      loading: false,
      saving: false,
      unsaved: false,
      form: {
        fees: {
          accountingService: {}
        },
        workflow: {
          invoiceDraft: false,
          invoiceApprove: false,
          invoiceReview: false,
          reviewer: false
        }
      },
      me: {},
      company: {}
    });
    onMounted(async () => {
      workflowState.loading = true;
      const me = await props.userService.getMe();
      workflowState.me = me;
      workflowState.company = JSON.parse(JSON.stringify(me.company));
      workflowState.form.workflow = JSON.parse(JSON.stringify(me.company.settings.workflow));
      workflowState.form.fees = JSON.parse(JSON.stringify(me.company.settings.fees || {}));
      workflowState.preview = workflowState.form.workflow;
      if (!workflowState.form.fees.accountingService) {
        workflowState.form.fees.accountingService = {
          id: undefined
        };
      }
      if (me.company.integration.quickbooks) {
        getServicesLists();
      }
      workflowState.loading = false;
      const deactivate = new RouteService(props).rootScopeChange().$on("$stateChangeStart", event => {
        if (somethingChanged.value) {
          workflowState.unsaved = true;
          setTimeout(() => {
            workflowState.unsaved = false;
          }, 4000);
          event.preventDefault();
        } else {
          deactivate();
        }
      });
    });
    function setOption(draft, approve, review) {
      workflowState.form.workflow.invoiceDraft = draft;
      workflowState.form.workflow.invoiceApprove = approve;
      workflowState.form.workflow.invoiceReview = review;
    }
    async function getServicesLists() {
      const list = await props.accountingService.services();
      workflowState.services = list.services.map(service => ({
        value: service.id,
        label: service.name,
        ...service
      }));
    }
    function optionSet(draft, approve, review) {
      const {
        invoiceReview,
        invoiceApprove,
        invoiceDraft
      } = workflowState.form.workflow || {};
      if (review) return invoiceReview && invoiceApprove;
      if (approve) return invoiceApprove && !invoiceReview;
      if (draft) return invoiceDraft && !invoiceApprove;
      return !invoiceDraft;
    }
    function showPreview(draft, approve, review) {
      workflowState.preview = {
        invoiceDraft: draft,
        invoiceApprove: approve,
        invoiceReview: review
      };
    }
    function restorePreview() {
      workflowState.preview = workflowState.form.workflow;
    }
    function accountingServiceChange() {
      nextTick(() => {
        workflowState.form.fees.accountingService = workflowState.services.find(s => s.value === workflowState.form.fees.accountingService?.id);
      });
    }
    function reviewerToggle(value) {
      workflowState.form.workflow.reviewer = value;
    }
    function saveSettings() {
      workflowState.saving = true;
      const update = {
        settings: {
          workflow: workflowState.form.workflow,
          fees: workflowState.form.fees
        }
      };
      companyStore.updateMyCompany(update).then(company => {
        workflowState.company = JSON.parse(JSON.stringify(company));
        workflowState.form.workflow = JSON.parse(JSON.stringify(company.settings.workflow));
        workflowState.form.fees = JSON.parse(JSON.stringify(company.settings.fees || {}));
        props.alerts.success("Your settings were saved.");
        props.userService.reload();
      }).catch(err => {
        props.alerts.error(err);
      }).finally(() => {
        workflowState.saving = false;
      });
    }
    function cancel() {
      workflowState.form.workflow = JSON.parse(JSON.stringify(workflowState.company.settings.workflow));
      workflowState.form.fees = JSON.parse(JSON.stringify(workflowState.company.settings.fees));
      accountingServiceChange();
    }
    const somethingChanged = computed(() => {
      const {
        form,
        company
      } = workflowState || {};
      if (JSON.stringify(form.workflow) !== JSON.stringify(company?.settings?.workflow)) {
        return true;
      }
      if (form.fees?.accountingService?.id !== company?.settings?.fees?.accountingService?.id) {
        return true;
      }
      if (form.fees.services !== company?.settings?.fees?.services) {
        return true;
      }
      if (form.fees.expenseInterest !== company?.settings?.fees?.expenseInterest) {
        return true;
      }
      if (form.fees.serviceLabel !== company?.settings?.fees?.serviceLabel) {
        return true;
      }
      return false;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MainHeader, {
        content: "Billing Workflow"
      }), _unref(workflowState).loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Billing',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[42] || (_cache[42] = _createElementVNode("p", null, " This determines when invoices are sent to the accounting system and what steps you want for approval. ", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["text-left bg-white hover:bg-gray-100 px-2", {
          'option-active': optionSet(false, false, false)
        }]),
        id: "direct",
        onClick: _cache[0] || (_cache[0] = $event => setOption(false, false, false)),
        onMouseenter: _cache[1] || (_cache[1] = $event => showPreview(false, false)),
        onMouseleave: _cache[2] || (_cache[2] = $event => restorePreview())
      }, [...(_cache[17] || (_cache[17] = [_createElementVNode("h5", {
        class: "font-normal"
      }, [_createElementVNode("b", null, "Direct")], -1), _createElementVNode("p", {
        class: "text-xs"
      }, " Invoices go directly to QuickBooks when they are created. This is appropriate for smaller firms that want to keep things simple. ", -1)]))], 34), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["text-left bg-white hover:bg-gray-100 px-2", {
          'option-active': optionSet(true, false, false)
        }]),
        id: "draft",
        onClick: _cache[3] || (_cache[3] = $event => setOption(true, false, false)),
        onMouseenter: _cache[4] || (_cache[4] = $event => showPreview(true, false, false)),
        onMouseleave: _cache[5] || (_cache[5] = $event => restorePreview())
      }, [...(_cache[18] || (_cache[18] = [_createElementVNode("h5", {
        class: "font-normal"
      }, [_createElementVNode("b", null, "Draft Step")], -1), _createElementVNode("p", {
        class: "text-xs"
      }, [_createTextVNode(" Invoices are created as drafts so that they can be reviewed and approved. Once approved, invoices are sent to QuickBooks. "), _createElementVNode("br")], -1)]))], 34), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["text-left bg-white hover:bg-gray-100 px-2", {
          'option-active': optionSet(true, true, false)
        }]),
        id: "draft-aprove",
        onClick: _cache[6] || (_cache[6] = $event => setOption(true, true, false)),
        onMouseenter: _cache[7] || (_cache[7] = $event => showPreview(true, true, false)),
        onMouseleave: _cache[8] || (_cache[8] = $event => restorePreview())
      }, [...(_cache[19] || (_cache[19] = [_createElementVNode("h5", {
        class: "font-normal"
      }, [_createElementVNode("b", null, "Draft and Approve Steps")], -1), _createElementVNode("p", {
        class: "text-xs"
      }, " Invoices are created as drafts and when approved they stay in LeanLaw. Approved invoices can be sent to QuickBooks individually or as a group later. ", -1)]))], 34), _unref(workflowState).me.features?.reviewer ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: _normalizeClass(["text-left bg-white hover:bg-gray-200 px-2", {
          'option-active': optionSet(true, true, true)
        }]),
        id: "draft-review",
        onClick: _cache[9] || (_cache[9] = $event => setOption(true, true, true)),
        onMouseenter: _cache[10] || (_cache[10] = $event => showPreview(true, true, true)),
        onMouseleave: _cache[11] || (_cache[11] = $event => restorePreview())
      }, [...(_cache[20] || (_cache[20] = [_createElementVNode("h5", {
        class: "font-normal"
      }, [_createElementVNode("b", null, "Draft, Review, and Approve Steps")], -1), _createElementVNode("p", {
        class: "text-xs"
      }, [_createTextVNode(" Invoices are created as drafts and can be sent to Review or Approved, where they can be sent to QuickBooks. "), _createElementVNode("br")], -1)]))], 34)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [_cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "py-2"
      }, [_createTextVNode(" Invoice WorkFlow Help: "), _createElementVNode("span", {
        "ll-support": "invoiceWorkflows"
      })], -1)), _cache[28] || (_cache[28] = _createElementVNode("h4", null, "The Workflow Selected", -1)), _createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("button", {
        type: "button",
        class: "btn",
        style: {
          "cursor": "normal"
        }
      }, " Ready to Bill ", -1)), _withDirectives(_createElementVNode("div", null, [...(_cache[21] || (_cache[21] = [_createElementVNode("div", null, [_createElementVNode("span", {
        style: {
          "font-size": "1.2em",
          "line-height": "2em"
        },
        class: "fa fa-arrow-down"
      })], -1), _createElementVNode("button", {
        type: "button",
        class: "btn",
        style: {
          "cursor": "normal"
        }
      }, " Draft ", -1)]))], 512), [[_vShow, _unref(workflowState).preview?.invoiceDraft]]), _withDirectives(_createElementVNode("div", null, [...(_cache[22] || (_cache[22] = [_createElementVNode("div", null, [_createElementVNode("span", {
        style: {
          "font-size": "1.2em",
          "line-height": "2em"
        },
        class: "fa fa-arrow-down"
      })], -1), _createElementVNode("button", {
        type: "button",
        class: "btn",
        style: {
          "cursor": "normal"
        }
      }, " Review ", -1)]))], 512), [[_vShow, _unref(workflowState).preview?.invoiceReview]]), _withDirectives(_createElementVNode("div", null, [...(_cache[23] || (_cache[23] = [_createElementVNode("div", null, [_createElementVNode("span", {
        style: {
          "font-size": "1.2em",
          "line-height": "2em"
        },
        class: "fa fa-arrow-down"
      })], -1), _createElementVNode("button", {
        type: "button",
        class: "btn",
        style: {
          "cursor": "normal"
        }
      }, " Approved ", -1)]))], 512), [[_vShow, _unref(workflowState).preview?.invoiceApprove]]), _cache[25] || (_cache[25] = _createElementVNode("div", null, [_createElementVNode("span", {
        style: {
          "font-size": "1.2em",
          "line-height": "2em"
        },
        class: "fa fa-arrow-down"
      })], -1)), _cache[26] || (_cache[26] = _createElementVNode("button", {
        type: "button",
        class: "btn",
        style: {
          "cursor": "normal"
        }
      }, [_createElementVNode("img", {
        src: _imports_0
      }), _createTextVNode(" QuickBooks ")], -1))])])]), _createElementVNode("div", null, [_unref(workflowState).me.features?.reviewer ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[31] || (_cache[31] = _createElementVNode("h4", null, "Reviewer", -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("label", null, [_cache[30] || (_cache[30] = _createTextVNode(" Assign Reviewer ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("Allows users to be assigned as the Reviewer for a matter from its Billing & Rates tab. Reviewers' names appear on all draft invoices for the matter and can be used as an invoice filter.", -1)]))]),
        _: 1
      })]), _createVNode(LlDoubleSwitch, {
        "model-value": !!_unref(workflowState).form.workflow?.reviewer,
        "left-label": "No",
        "right-label": "Yes",
        "onUpdate:modelValue": reviewerToggle
      }, null, 8, ["model-value"])])])) : _createCommentVNode("", true), _cache[41] || (_cache[41] = _createElementVNode("h4", {
        class: "mt-4"
      }, "Fees", -1)), _createVNode(ProductNotice, {
        state: __props.state,
        label: 'Adminstrative fees and Expense interest are',
        product: 'adminFees',
        trial: true
      }, null, 8, ["state"]), _unref(workflowState).me.features?.adminFees ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("label", null, [_cache[33] || (_cache[33] = _createTextVNode("Administrative Fee ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("span", null, "This will be added as a separate line item to all invoices based on hourly and fixed fees services on the invoice.", -1)), _unref(workflowState).me.features?.settlementTab ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Admin fees will not be auto created on invoices created through the settlement workflow.")) : _createCommentVNode("", true)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("input", {
        type: "number",
        step: "any",
        class: "w-full",
        style: {
          "width": "70%",
          "padding": "14px"
        },
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(workflowState).form.fees.services = $event),
        name: "name"
      }, null, 512), [[_vModelText, _unref(workflowState).form.fees.services]]), _cache[34] || (_cache[34] = _createElementVNode("span", {
        class: "add-on"
      }, "%", -1))])])]), _withDirectives(_createElementVNode("div", _hoisted_15, [_cache[35] || (_cache[35] = _createElementVNode("div", {
        class: "w-6/12"
      }, [_createElementVNode("label", null, "Invoice Label")], -1)), _createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("input", {
        type: "text",
        class: "w-full",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(workflowState).form.fees.serviceLabel = $event),
        name: "name",
        placeholder: "Administrative Fee ({{fees.services}}%)",
        style: {
          "width": "100%"
        }
      }, null, 512), [[_vModelText, _unref(workflowState).form.fees.serviceLabel]])])], 512), [[_vShow, _unref(workflowState).form.fees.services]]), _unref(workflowState).form.fees.services && _unref(workflowState).me.company.integration.quickbooks ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[37] || (_cache[37] = _createElementVNode("div", {
        class: "w-6/12"
      }, [_createElementVNode("label", null, "Product/Service")], -1)), _createElementVNode("div", _hoisted_18, [_createVNode(LlSelect, {
        modelValue: _unref(workflowState).form.fees.accountingService.id,
        "onUpdate:modelValue": [_cache[14] || (_cache[14] = $event => _unref(workflowState).form.fees.accountingService.id = $event), _cache[15] || (_cache[15] = $event => accountingServiceChange())],
        items: _unref(workflowState).services,
        "item-value": "value",
        "return-object": false,
        placeholder: "Select Product/Service",
        clearable: false,
        "hide-details": true
      }, null, 8, ["modelValue", "items"]), _cache[36] || (_cache[36] = _createElementVNode("p", null, "Leave blank to use same product/service as expenses", -1))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("label", null, [_cache[39] || (_cache[39] = _createTextVNode("Interest on Expenses ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[38] || (_cache[38] = [_createTextVNode("When enabled in a matter's Billing and Rates tab, causes the Contingency Statement report to calculate an annual interest rate on that matter's expenses. Visible on the report's second level.", -1)]))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_withDirectives(_createElementVNode("input", {
        type: "number",
        step: "any",
        class: "w-full",
        style: {
          "width": "70%",
          "padding": "14px"
        },
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(workflowState).form.fees.expenseInterest = $event),
        name: "name"
      }, null, 512), [[_vModelText, _unref(workflowState).form.fees.expenseInterest]]), _cache[40] || (_cache[40] = _createElementVNode("span", {
        class: "add-on"
      }, "%", -1))])])])])) : _createCommentVNode("", true)]), _createVNode(SettingsSaveBar, {
        somethingChanged: somethingChanged.value,
        saving: _unref(workflowState).saving,
        unsaved: _unref(workflowState).unsaved,
        onUpdate: saveSettings,
        onCancel: cancel
      }, null, 8, ["somethingChanged", "saving", "unsaved"])]))]);
    };
  }
};